import React, { Component } from 'react';
 
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';

import './FAQ.css';
import 'react-accessible-accordion/dist/minimal-example.css';

class Terms extends Component {

  componentWillMount = () => {
    document.title = 'FAQ';
  }

  render() {
    return(
      <div className='terms'>
        <h1>Vragen en antwoorden</h1>
        <h2>Gebruik app - algemeen</h2>
        <Accordion>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>1. Waar gebruiken jullie de app voor?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>We gebruiken de app om onze gasten te informeren over onze restaurants, producten, services, McDonald’s nieuws en natuurlijk gepersonaliseerde coupons. Zo kan je bijvoorbeeld genieten van extra voordeel op je favoriete burger en meedoen aan toffe winacties!</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>2. Wanneer worden er nieuwe functionaliteiten toegevoegd aan de App?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>We werken elke dag aan nieuwe functionaliteiten om de ervaring van de gasten nog beter en makkelijker te maken. Wanneer we een nieuwe functionaliteit toevoegen aan de app zullen we dat uiteraard melden via onze website en social media.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>3. Kan ik de App ook gebruiken in andere landen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Zeker, maar niet in alle landen. Open je McDonald's App, klik op "Meer", klik op "Regio & taal" en bekijk welke landen de McDonald's App aanbieden.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>4. Kan ik ook McDelivery via de nieuwe app gebruiken?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, direct bestellen via de McDonald’s app is op dit moment nog niet mogelijk, hier heb je de app van Uber Eats of Thuisbezorgd.nl voor nodig. Voor meer informatie over McDelivery en een overzicht van steden waar we nu bezorgen vind je hier: <a href='https://mcdelivery.mcdonalds.nl'>https://mcdelivery.mcdonalds.nl</a>.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>5. Waar vind ik promoties, voedingswaarden en allergeneninformatie, de restaurant zoeker, services en openingstijden per restaurant?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Bij iPhones vind je het menu onderaan het scherm.  Bij Android toestellen kan je het menu uitklappen via de knop linksboven op het scherm.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>6. Is er een internetverbinding noodzakelijk om de App te gebruiken?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Ja, het is noodzakelijk dat je verbonden bent met internet om de App te kunnen gebruiken.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>7. Kan iedereen een account aanmaken in de nieuwe App?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, net als bij de vorige versie van de App kan je vanaf 16 jaar een account aanmaken wanneer de privacy verklaring is gelezen door een ouder of voogd. Wanneer je jonger bent dan zestien is het niet mogelijk om een account aan te maken. Vanaf 18 jaar mag iedereen een account aanmaken.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>8. Krijg ik als App gebruiker een verjaardagscadeautje?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Jazeker! Als McDonald’s fan krijg jij van ons op je verjaardag een cadeautje in de vorm van een verjaardagscoupon. Vergeet hiervoor niet je geboortedatum in te vullen in de ‘Mijn Account’ sectie te vinden in het uitgebreide menu.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>9. Waarom worden er geen prijzen vermeld bij de producten in de App?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>De prijzen kunnen per restaurant verschillen, deze worden getoond op de menuborden in de McDrive of in het Restaurant.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>10. Ik krijg een foutmelding. Hoe los ik dit op?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Als je een foutmelding krijgt in de app is het handig om de volgende punten na te gaan: <br/>
1.  Is de mobiele software bijgewerkt naar de nieuwste versie? <br/>
2.  Is de nieuwste app versie gedownload?<br/>
3.  Is de internet verbinding goed? Test zowel op Wi-Fi als mobiele netwerk zoals 3G of 4G.<br/>
4.  Staan de tijds en datum instellingen goed? Automatisch op de correcte dag/tijd?<br/>
5.  Is de telefoon niet geroot of jailbroken? Als dit wel zo is kan je geen gebruik maken van de app.<br/>
6.  Heb je geprobeerd de app van de telefoon te verwijderen en opnieuw te downloaden?<br/>
7.  Ben je ingelogd in de app met je account?</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
        </Accordion>
        <h2>Gebruik app - privacy</h2>
        <Accordion>
         <AccordionItem>
            <AccordionItemTitle>
               <h3>1. Voldoet de App aan de GDPR/AVG regelgeving omtrent privacy?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Jazeker! Vanzelfsprekend hebben wij bij het bouwen van de App ervoor gezorgd dat alles voldoet aan de laatste richtlijnen van de AVG/GDPR. Op deze pagina (<a href='https://www.mcdonalds.nl/privacy-cookie-verklaring'>https://www.mcdonalds.nl/privacy-cookie-verklaring</a>) leggen we uit hoe we hiermee omgaan en hoe je jouw gegevens kan opvragen mocht je hier benieuwd naar zijn.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>2. Is het mogelijk om mijn McDonald’s App account te verwijderen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Ja hoor. Dit kan zowel direct in de App (kies voor ‘Uitloggen’ in de ‘Mijn Account’ sectie en volg dan de link naar de website in het getoonde scherm) of via de Chief Privacy Officer van McDonalds Nederland, per e-mail te bereiken via <a href='mailto:privacy@nl.mcd.com'>mailto:privacy@nl.mcd.com</a>. Let op, wanneer je uitlogt of je account verwijderd kun je geen gebruik meer maken van de Coupons of Winacties in de App.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
        </Accordion>


        <h2>Gebruik app – Deals & Rewards</h2>
        <Accordion>
         <AccordionItem>
            <AccordionItemTitle>
               <h3>1. Kan ik zonder account Deals ontvangen en gebruiken of sparen voor MyMcDonald’s Rewards?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee. Om ervoor te zorgen dat we iedereen kortingen kunnen bieden die het meest relevant zijn is een account nodig. Ook voor winacties vragen we je om een account aan te maken, zodat iedereen evenveel kans maakt om te winnen.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>2. Hoe gebruik ik een Deal of Reward aan de Kiosk?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Selecteer een Deal / Reward en activeer deze in de App voordat je gaat bestellen. Scan de QR-code op de Kiosk bij de scanner naast het pinautomaat. Lukt het scannen niet? Klik dan op de knop APP en vul de M-cijfercode handmatig in.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>3. Hoe gebruik ik een Deal / Reward aan de Kassa?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Selecteer een Deal / Reward en activeer deze in de App voordat je gaat bestellen. Scan de QR-code middels de scanner naast de kassa. Lukt het scannen niet? Lees de M-cijfercode voor, de medewerker voert de code handmatig in zodat de korting alsnog op de bestelling wordt toegepast.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>4. Hoe gebruik ik een Deal / Reward in de McDrive?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Selecteer een Deal / Reward en plaats je bestelling bij de bestelzuil in de McDrive. Rijd vervolgens door naar het eerste raam en laat daar je QR-code scannen voordat je begint met afrekenen. Lukt het scannen niet? Lees de M-cijfercode voor, de medewerker voert de code handmatig in zodat de korting alsnog op de bestelling wordt toegepast.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>5. Hoe vaak kan ik mijn Deal of Reward gebruiken?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Je kan je Deal of Reward maximaal één keer gebruiken in één bestelling. Het is wel mogelijk om meerdere verschillende Deals of Rewards toe te voegen in één bestelling. </p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>6. Waar vind ik MyMcDonald’s Rewards?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>MyMcDonald’s vind je in de MyMcDonald’s App onder Deals. Dit is alleen terug te vinden als je de nieuwe App-voorwaarden hebt geaccepteerd.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>7. Wat is de waarde van de MyM punten?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Voor elke euro die je uitgeeft, ontvang je 10 MyRewards punten.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>8. Waar kan ik voor sparen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Met MyMcDonald’s Rewards kun je sparen voor gratis McDonald’s favorieten. Dit kan variëren van heerlijke burgers, drankjes, desserts, snacks tot andere leuke verrassingen.  In de App vind je een overzicht van alle producten waar je voor kunt sparen.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>9. Is er een limiet aan het aantal punten waarvoor ik kan sparen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Ja, je kunt maximaal sparen tot 10.000 punten. Verzilver dus eerst een aantal punten voordat je weer verder kunt sparen.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>10.  Hoe lang zijn mijn punten geldig?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>De punten zijn 12 maanden geldig.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>11.  Is het mogelijk om punten te sparen via McDelivery?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, het programma is enkel te gebruiken bij bestellingen in het restaurant of via de McDrive.  Het is niet mogelijk om punten te sparen via onze McDelivery partners omdat er geen directe verbinding is tussen de App en Uber Eats / Thuisbezorgd.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>12.  Waarom moet ik mijn McDonald’s App account in twee stappen verifiëren?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Verificatie in twee stappen vereist het gebruik van iets wat je weet (wachtwoord) en iets dat je hebt (authenticatie op je telefoon). Zo bieden we extra beveiliging aan jouw account en jouw persoonlijke gegevens. En ben je helemaal gereed voor alle toekomstige functionaliteiten in de McDonald’s App.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>13.  Wanneer worden mijn punten afgeschreven?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>De punten worden direct afschreven en binnen 30 minuten zichtbaar bij je punten Historie. Wil je jouw historie bekijken? Klik dan op je MyM card en op de tab “Historie”.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>14.  Kan ik meerdere producten bestellen in één bestelling?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, je kunt maximaal 1 product bestellen per keer. Plaats nog een bestelling als je graag nog een product wil. </p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>15.  Ik ontvang geen orderbevestiging per mail?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>De bevestigingsmail wordt direct verzonden na het plaatsen van een bestelling. Afhankelijk van jouw mailprovider ontvang je de mail binnen 15 minuten. De mail wordt verstuurd naar het emailadres gekoppeld aan het App account. Controleer goed je inbox, spam en verwijdere items.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>16.  Wanneer ontvang ik mijn bestelling?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>De bestelling wordt binnen 2 á 3 weken via de (PostNL) brievenpost geleverd. Je hoeft hiervoor niet thuis te zijn.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>17.  Ontvang ik een track and trace link van mijn pakketje?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, je ontvangt geen track and trace van het pakket.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>18.  Kan ik mijn bestelling annuleren of wijzigen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, na het plaatsen van de bestelling kan deze niet geannuleerd of gewijzigd worden. Controleer dus goed alle gegevens voordat je de bestelling plaatst. </p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>19.  Kan ik een product ruilen voor een ander product? </h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Nee, dit is niet mogelijk.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>20.  Mag ik de bestelling ook af laten leveren op een ander adres?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Ja hoor, vul de gegevens in waar het product afgeleverd moet worden. Graag de voornaam, achternaam en correcte adresgegevens. De orderbevestiging wordt gestuurd naar het emailadres gekoppeld aan het App account.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>21.  Mijn pakketje is na 3 weken nog niet binnen, wat moet ik doen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Neem contact met ons op via <a href='https://www.facebook.com/mcdonaldsnederland/?openOutsideMcd=true'>Facebook Messenger</a> of <a href=' https://www.instagram.com/mcdonaldsnl/?openOutsideMcd=true'>Instagram</a>, wij kijken graag met je mee.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>22.  Waar kan ik meer lezen over mijn herroepingsrecht?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Je kunt binnen 14 dagen na ontvangst van het product gebruik maken van jouw herroepingsrecht. Download en print <a href='https://www.mcdonalds.com/content/dam/nl/pdf/MyM%20Fanshop%20-%20herroepingsformulier.pdf?openOutsideMcd=true'>hier</a> het formulier. </p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>23.  Waar vind ik de algemene voorwaarden?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p><a href='https://www.mcdonalds.com/nl/nl-nl/algemene_voorwaarden.html?openOutsideMcd=true'>Bekijk deze pagina</a></p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemTitle>
               <h3>24.  Hoe kan ik een uitje kopen?</h3>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="extendable_content">
                <p>Zodra je genoeg punten hebt gespaard kan je kiezen uit de beschikbare uitjes. De aankoop van de vouchers gaan via Queueup. Via haar ga je een overeenkomst aan met het gekozen uitje.</p>
              </div>
            </AccordionItemBody>
          </AccordionItem>
        </Accordion>
        <h2>Heb je vragen?</h2>
        <p>Heb je na het lezen van deze informatie nog vragen?  Neem dan contact met ons op via <a href='https://www.mcdonalds.nl/contactgegevens'>https://www.mcdonalds.nl/contactgegevens</a>. Veel plezier met de app!</p>
      </div>
    )
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/FAQ.jsx